<app-task-running-cancellation
  [layer]="layer"
  (viewFlow)="viewFlow.emit($event)"
/>
@if (insuranceFlowData?.insuranceType === 'CENTRALISATION') {
  <app-centralisation-history class="d-block" />
} @else {
  <app-task-history class="d-block" />
}
@if (!isLoading) {
  <app-task-user-profile-info class="mt-12 d-block" />

  @if (lead) {
    <app-expansion-panel
      class="mt-12"
      i18n-title
      title="Informations de la demande"
      [collapsed]="
        leadStep === LeadStep.POLICY ||
        leadStep === LeadStep.OFFER_ACCEPTED ||
        leadStep === LeadStep.SUBMISSION
      "
    >
      <app-lead-metadata-details-v2 class="d-block mt-8" [lead]="lead" />
    </app-expansion-panel>

    @if (insuranceFlowData?.insuranceType !== 'CENTRALISATION') {
      <app-expansion-panel
        class="mt-12"
        i18n-title
        title="Offres"
        [collapsed]="
          leadStep === LeadStep.POLICY ||
          leadStep === LeadStep.OFFER_ACCEPTED ||
          leadStep === LeadStep.SUBMISSION
        "
      >
        <div expansionPanelHeaderActions>
          <app-add-proposal-modal
            #addProposalModal
            [leadId]="lead.leadId"
            [disableNavigation]="true"
            [preload]="false"
            (proposalAdded)="refresh()"
          />
          @if (
            leadStep === LeadStep.INSURANCE || leadStep === LeadStep.PROPOSAL
          ) {
            <div class="task-details__proposals-header">
              <button
                type="button"
                class="lty-btn lty-btn-white d-flex align-items-center gap-1"
                (click)="addProposalModal.openModal()"
              >
                <app-plus-icon height="16px" width="16px" />
                <ng-container i18n>Ajouter une offre</ng-container>
              </button>
            </div>
          }
        </div>

        <app-proposals-actions
          class="d-block mt-8"
          [leadId]="lead.leadId"
          [proposals]="proposals"
          [lngCode]="languageCode"
          [showViewIcon]="false"
          [singleRowScrollable]="true"
          (editProposal)="addProposalModal.openModal($event)"
          (proposalsChanged)="refresh()"
        />
      </app-expansion-panel>
    }
  }
  @if (policy) {
    <app-task-policy-info class="d-block mt-12" />
    <app-flow-invoices class="mt-12 d-block" />
  }
  <app-task-cancellations [layer]="layer" />
  @if (policy) {
    <app-task-policy-documents class="d-block mt-12" />
  }
  <app-task-log class="mt-12 d-block" />
}
